import type { AssistantHistoryMessage } from '@triedge/ai-assistant-ui';

type AssistantHistoryLike = {
  role?: unknown;
  content?: unknown;
};

export const normalizeAssistantConversationHistoryForRequest = (
  history: readonly AssistantHistoryLike[],
): AssistantHistoryMessage[] => {
  const normalized: AssistantHistoryMessage[] = [];

  history.forEach((message) => {
    const normalizedRole = message.role === 'user' || message.role === 'assistant'
      ? message.role
      : null;
    const normalizedContent = typeof message.content === 'string'
      ? message.content.trim()
      : '';
    if (!normalizedRole || normalizedContent.length === 0) {
      return;
    }
    if (normalized.length === 0 && normalizedRole !== 'user') {
      return;
    }

    const previousMessage = normalized[normalized.length - 1];
    if (previousMessage?.role === normalizedRole) {
      previousMessage.content = `${previousMessage.content}\n\n${normalizedContent}`;
      return;
    }

    normalized.push({
      role: normalizedRole,
      content: normalizedContent,
    });
  });

  return normalized;
};

export const stripCurrentQuestionFromAssistantConversationHistory = (
  history: readonly AssistantHistoryMessage[],
  question: string,
): AssistantHistoryMessage[] => {
  const normalizedQuestion = question.trim();
  if (!normalizedQuestion || history.length === 0) {
    return [...history];
  }

  const nextHistory = [...history];
  const lastMessage = nextHistory[nextHistory.length - 1];
  if (!lastMessage || lastMessage.role !== 'user') {
    return nextHistory;
  }

  if (lastMessage.content === normalizedQuestion) {
    return nextHistory.slice(0, -1);
  }

  const mergedSuffix = `\n\n${normalizedQuestion}`;
  if (!lastMessage.content.endsWith(mergedSuffix)) {
    return nextHistory;
  }

  const previousContent = lastMessage.content.slice(0, -mergedSuffix.length).trimEnd();
  if (!previousContent) {
    return nextHistory.slice(0, -1);
  }

  nextHistory[nextHistory.length - 1] = {
    ...lastMessage,
    content: previousContent,
  };
  return nextHistory;
};
